import { api } from '@/lib/api-manager'

export async function denyReview(requestId: string, observation: string) {
  const result = await api.post(`v1/requests/request/${requestId}/deny`, {
    observation
  })
  return result.data
}
